// extracted by mini-css-extract-plugin
export default {"secondImage":"secondImage_FigiG","fade":"fade_aM4sC","fade-in-animation":"fade-in-animation_e6sdU"};